import { DistributorProfile, ProductType } from "../types";

export type ClientProductConfig = {
  key: ProductType;
  label: string;
  subText: string;
  enabled: (profile: DistributorProfile) => boolean;
};

export const CLIENT_PRODUCTS: ClientProductConfig[] = [
  {
    key: "MF",
    label: "Mutual Funds",
    subText: "",
    enabled: () => true,
  },
  {
    key: "SIF",
    label: "SIFs",
    subText: "High ticket investments",
    enabled: (profile) => !!profile.sif_euin,
  },
  {
    key: "GIFT",
    label: "GIFT",
    subText: "Global Exposure",
    enabled: (profile) => !!profile.gift_city_flag,
  },
];

export function getProductLabel(key: ProductType) {
  const product = CLIENT_PRODUCTS.find((p) => p.key === key);
  if (!product) throw new Error("Invalid Product");
  return product.label;
}

export const ALL_PRODUCTS: ProductType[] = ["MF", "SIF", "GIFT"];

export const NON_GIFT_PRODUCTS: ProductType[] = ["MF", "SIF"];
